export const INGREDIENT_FETCHED = 'products.INGREDIENT_FETCHED';
export const PIZZA_FETCHED = 'products.PIZZA_FETCHED';
export const PIZZA_SAUCE_FETCHED = 'products.PIZZA_SAUCE_FETCHED';
export const PIZZA_SAUCE_REQUEST = 'products.PIZZA_SAUCE_REQUEST';
export const PIZZA_CATEGORY_FETCHED = 'products.PIZZA_CATEGORY_FETCHED';
export const PIZZA_CATEGORY_REQUEST = 'products.PIZZA_CATEGORY_REQUEST';
export const PRODUCT_FETCHED = 'products.PRODUCT_FETCHED';
export const PRODUCT_CATEGORY_FETCHED = 'products.PRODUCT_CATEGORY_FETCHED';
export const PRODUCT_CATEGORY_REQUEST = 'products.PRODUCT_CATEGORY_REQUEST';
export const PRODUCT_CATEGORY_FILTER = 'products.PRODUCT_CATEGORY_FILTER';
export const PRODUCT_TYPE_FETCHED = 'products.PRODUCT_TYPE_FETCHED';
export const PRODUCT_TYPE_REQUEST = 'products.PRODUCT_TYPE_REQUEST';
export const PRODUCT_TYPE_FILTER = 'products.PRODUCT_TYPE_FILTER';


// WEBPACK FOOTER //
// ./src/types/product.js